module.exports = __webpack_public_path__ + "img/trending-up.a7a33f0e.svg";